module.exports = __webpack_public_path__ + "img/building.47509d4f.png";